<template>
  <v-row no-gutters>
    <v-col cols="12">
      <widget-partitions-watermeters
        v-bind="$props"
        v-if="isLoaded"
        :watermeters="watermeters"
        :has-legalization="hasLegalization"
        :has-water-usage="hasWaterUsage"
        :has-watermeter-kind="hasWatermeterKind"
        :has-parent-watermeter="hasParentWatemeter"
        @refetchPartitionWatermeters="init"
      >
      </widget-partitions-watermeters>
      <main-loader v-else> </main-loader>
    </v-col>
  </v-row>
</template>

<script>
import { get, call } from 'vuex-pathify';

import MainLoader from '@/components/MainLoader';
import WidgetPartitionsWatermeters from '@/components/WidgetPartitionsWatermeters';

export default {
  name: 'WidgetPartitionsWatermetersWrapper',
  components: {
    MainLoader,
    WidgetPartitionsWatermeters,
  },
  props: {
    partitionId: {
      type: [Number, String],
      required: true,
    },
    canEdit: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isLoaded: false,

    watermeters: [],
  }),
  computed: {
    hasLegalization() {
      return this.legalizationAttributeName !== null;
    },
    hasWaterUsage() {
      return this.waterUsageAttributeName !== null;
    },
    hasWatermeterKind() {
      return this.watermeterKindAttributeName !== null;
    },
    hasParentWatemeter() {
      return this.parentWatemeterAttributeName !== null;
    },
    legalizationAttributeName: get(
      'admin/modulesMapping@billing.watermeters_datasource_attributes_mapping.legalization_attribute_name'
    ),
    waterUsageAttributeName: get(
      'admin/modulesMapping@billing.watermeters_datasource_attributes_mapping.water_usage_attribute_name'
    ),
    watermeterKindAttributeName: get(
      'admin/modulesMapping@billing.watermeters_datasource_attributes_mapping.watermeter_kind_attribute_name'
    ),
    parentWatemeterAttributeName: get(
      'admin/modulesMapping@billing.watermeters_datasource_attributes_mapping.parent_attribute_name'
    ),
  },
  methods: {
    getPartitionWatermeters: call('billings/getPartitionWatermeters'),
    async init() {
      try {
        this.isLoaded = false;
        const r = await this.getPartitionWatermeters({ partition_id: this.partitionId });
        this.watermeters = r.data.data;
        this.isLoaded = true;
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="scss" scoped></style>
